/**
 * CagesTableV16 - v16 Handsontable table component for cage creation.
 * Uses v16 editors, validators, and renderers via SpreadsheetV16.
 */
import type { FC, ReactNode, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';

import SpreadsheetV16 from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16.model';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTableV16';
import { defaultMetadataToColumnSettingMapperV16 } from '@/support/hot-v16';

interface CagesTableV16Props {
  data: Array<Record<string, unknown>>;
  innerRef: RefObject<HotTableRef>;
  settings: SpreadsheetV16Settings;
  setSettings: (settings: SpreadsheetV16Settings) => void;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  setInvalid: (invalid: boolean) => void;
  overlay?: ReactNode;
  maxRows?: number;
  afterRemoveRow?: () => void;
  afterContextMenuHide?: () => void;
}

const CagesTableV16: FC<CagesTableV16Props> = ({
  data,
  innerRef,
  settings,
  setSettings,
  metadata,
  setMetadata,
  setInvalid,
  overlay,
  maxRows,
  afterRemoveRow,
  afterContextMenuHide,
}) => {
  return (
    <SpreadsheetV16
      className="cageCreation"
      testPrefix="cage-creation-v16"
      data={data}
      innerRef={innerRef as RefObject<HotTableRef>}
      settings={settings}
      setSettings={setSettings}
      metadata={metadata}
      setMetadata={setMetadata}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapperV16}
      setInvalid={setInvalid}
      overlay={overlay}
      maxRows={maxRows}
      afterRemoveRow={afterRemoveRow}
      afterContextMenuHide={afterContextMenuHide}
      buttonClasses="absolute-sheet-buttons-v16"
    />
  );
};

export default CagesTableV16;
